export function linkToOfflineTokenExpired() {
  return "/offline/token-expired";
}
